module.exports = __webpack_public_path__ + "static/img/chuzhongshuxue4.c88580ac.jpg";